module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Your Blueprint for Life: How to Align Your Passion, Gifts, and Calling With Eternity In Mind")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct2",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-02-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3#toc3",
      "id": "con3"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUEPRINT FOR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-03-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5#toc5",
      "id": "con5"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 2: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v(" I H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERE")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-04-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#toc7",
      "id": "con7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIQUE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLING")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-05-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9a#toc9a",
      "id": "con9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4: B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-06-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10a#toc10a",
      "id": "con10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NFINITY AND")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EYOND")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-07-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11a#toc11a",
      "id": "con11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6: B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILDING")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIEF")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-08-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12a#toc12a",
      "id": "con12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IG")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-09-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13a#toc13a",
      "id": "con13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 8: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITUAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRATEGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-10-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14a#toc14a",
      "id": "con14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 9: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELATIONAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRATEGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "P0007-11-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16a#toc16a",
      "id": "con16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 10: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HYSICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRATEGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-12-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#toc17",
      "id": "con17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 11: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INANCIAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRATEGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-02-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#toc19",
      "id": "con19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 12: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRATEGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-03-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#toc21",
      "id": "con21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 13: A V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEW FROM THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORCH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WING")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    staticStyle: {
      "margin-top": "1.2em"
    },
    attrs: {
      "id": "p0008-04-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#toc23",
      "id": "con23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-05-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#toc24",
      "id": "con24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0008-06-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#toc25",
      "id": "con25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Abouth the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0